import { render, staticRenderFns } from "./reasonDescription.vue?vue&type=template&id=56c4d6c8&scoped=true&"
import script from "./reasonDescription.vue?vue&type=script&lang=js&"
export * from "./reasonDescription.vue?vue&type=script&lang=js&"
import style0 from "./reasonDescription.vue?vue&type=style&index=0&id=56c4d6c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c4d6c8",
  null
  
)

export default component.exports